import React, { useEffect, useState } from 'react';
import { getApiUrl } from '../../utils/api';
import { useNotification } from '../../contexts/NotificationContext';

const RenameFolderModal = ({ isOpen, onClose, onSuccess, folder }) => {
  const { showError, showSuccess } = useNotification();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && folder) {
      setName(folder.name || '');
      setDescription(folder.description || '');
    }
  }, [isOpen, folder]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!folder) return;
    if (!name.trim()) {
      showError('Nome da pasta é obrigatório');
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(getApiUrl(`test-repository/folders/${folder.id}`), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ name: name.trim(), description: description || null })
      });
      if (res.ok) {
        const data = await res.json();
        showSuccess('Pasta atualizada com sucesso');
        onSuccess && onSuccess(data);
        handleClose();
      } else {
        const errData = await res.json().catch(() => ({}));
        showError(errData.error || 'Erro ao atualizar pasta');
      }
    } catch (err) {
      console.error('Erro ao atualizar pasta:', err);
      showError('Erro ao atualizar pasta');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setLoading(false);
    onClose && onClose();
  };

  if (!isOpen || !folder) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>Renomear Pasta</h2>
          <button className="modal-close" onClick={handleClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label>Nome *</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Descrição</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
              />
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RenameFolderModal;